// cfgreftables

import http from '../../../store/api/http' 

const actions = {
    getCfgRefTables(context, param) {
		return new Promise((resolve, reject) => {
			http.get('/api/cfgreftables')
			.then(function (response) {
		    	context.commit('getCfgRefTables', response.data)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    updateCfgRefTables(context, data) {
		return new Promise((resolve, reject) => {
			http.post('/api/cfgreftables', data)
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },

};

export default actions;